export default {
  // Messages that correspond to each route 'meta.home'
  route: {
    home: 'Home',
    site: 'Site',
    item: 'Item',
    nested_item: 'Nested Item',
    very_nested_item: 'Very Nested Item',
  },

  // Global messages
  message: {
    search: 'Search',
  },
};
